import { render, staticRenderFns } from "./FuheAi.vue?vue&type=template&id=647c43da&scoped=true&"
import script from "./FuheAi.vue?vue&type=script&lang=js&"
export * from "./FuheAi.vue?vue&type=script&lang=js&"
import style0 from "./FuheAi.vue?vue&type=style&index=0&id=647c43da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c43da",
  null
  
)

export default component.exports